(() => {
  const init = () => {
    const root = document.querySelector('.cc-approved-product[data-cc-pick-any-3="true"]');
    if (!root) return;

    const shell = root.querySelector('.cc-pick-three-builder-shell');
    const slot = root.querySelector('#mbcBundleItems');
    if (!shell || !slot) return;

    const wrongWidgetSelectors = [
      '#mbcBundleItemsWidget',
      '[data-mbc-bundle-items-widget]'
    ];

    const hideWrongWidgets = () => {
      wrongWidgetSelectors.forEach((selector) => {
        document.querySelectorAll(selector).forEach((el) => {
          if (el === slot || slot.contains(el)) return;
          el.setAttribute('data-cc-suppressed-mbc-widget', 'true');
          el.style.setProperty('display', 'none', 'important');
        });
      });
    };

    const removeDuplicateBundleTargets = () => {
      document.querySelectorAll('[id="mbcBundleItems"]').forEach((el) => {
        if (el === slot) return;
        if (!slot.children.length && el.children.length) {
          while (el.firstChild) slot.appendChild(el.firstChild);
        }
        el.setAttribute('data-cc-suppressed-mbc-duplicate', 'true');
        el.style.setProperty('display', 'none', 'important');
      });
    };

    const markReady = () => {
      removeDuplicateBundleTargets();
      const hasContent = slot.children.length > 0 || slot.textContent.trim().length > 0;
      if (hasContent) {
        shell.classList.add('is-ready');
        shell.classList.remove('is-empty');
        hideWrongWidgets();
        return true;
      }
      return false;
    };

    // MBC can render after the rest of the product page. Keep watching long enough
    // for the app to populate the dedicated bundle-page target documented by MBC.
    const observer = new MutationObserver(() => markReady());
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });

    markReady();

    window.setTimeout(() => {
      if (!markReady()) {
        // Preserve checkout functionality if MBC fails to populate its documented
        // bundle-page target. In that case, do not suppress any fallback widget.
        shell.classList.add('is-empty');
      }
      observer.disconnect();
    }, 12000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
